export default __webpack_public_path__ + "static/map-17dd98924f30593f56b88594afd77a36.jpg";